import { element } from 'protractor';
import { EventTypes } from './../../shared/EventTypes';
import { Auth } from './../Auth';
import { Account } from './../models/account';
import { AutenticationEventType } from './../autentication.event.type';
import { AppEventDispatcher } from './../../utils/AppEventDispatcher';
import { TweenMax, Quint, Sine } from 'gsap';
import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { User } from '../models/user';
import { Router } from '@angular/router';
import { OnDestroy } from '@angular/core/src/metadata/lifecycle_hooks';
import { AutenticationService } from '../autentication.service';
import { ThemeService } from '../../shared/theme-service/theme.service';

@Component({
	selector: 'app-accounts-list',
	templateUrl: './accounts-list.component.html',
	styleUrls: ['./accounts-list.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class AccountsListComponent implements OnInit, OnDestroy {

	view = '[data-component="accounts-list"]';
	cnpjMask: (string | RegExp)[];
	selectedAccount: string;
	scrollbarOptions: { axis: 'y', theme: 'minimal-dark' };
	accountsList: Array<Account>;
	active = false;
	findedAccount = Array<Account>();
	filteredAccountList = Array<Account>();
	sending: boolean;
	myAccountsList = [];
	outersAccountsList = [];

	@Input() cookie: Array<Account>;

  constructor(
    private router: Router,
    private authService: AutenticationService
  ) {
		AppEventDispatcher.listen(AutenticationEventType.LOGIN.ACCOUNTS_LIST, (data) => {
			this.show(data);
		});
	}

	ngOnInit() {
		this.cnpjMask = [/\d/, /\d/, '.' , /\d/, /\d/, /\d/, '.' , /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/];
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(AutenticationEventType.LOGIN.ACCOUNTS_LIST);
	}

	selectAccount(account, e) {
		this.selectedAccount = account;

		$('.item-list').removeClass('selected');
		e.currentTarget.classList.add('selected');

		this.findedAccount = Auth.getInstance().getAccountsList().filter(this.accountCompare, this.selectedAccount);

		// this.filteredAccountList = Auth.getInstance().getAccountsList().filter(this.accountsFilter, this.selectedAccount);
	}

	accountsFilter(item, index, array) {
		return (item.user.accountNumber !== this);
	}

	accountCompare(item, index, array) {
		return (item.user.accountNumber === this);
	}

	checkKey(account, event) {
		if (event.keyCode === 13) {
			this.selectedAccount = account;
		}
	}

	checkAccessPix() {
		this.authService.getPixAccessAvailable().subscribe(data => {
			if (data.Sucesso) {
				const user: User = Auth.getInstance().getUser();
				user.accessPix = data.Retorno;
				Auth.getInstance().setUser(user);
				AppEventDispatcher.dispatch(EventTypes.MENU.CHANGE, { show: true });
			}
		});
	}

	send() {

		if (this.selectedAccount) {

			this.findedAccount[0].user.rule = this.findedAccount[0].rights;
			Auth.getInstance().setUser(this.findedAccount[0].user);

			this.sending = true;

			this.authService.setAccount().subscribe( data => {
				this.checkAccessPix();
				this.sending = false;
				this.hide();
				if (!Auth.hasSecurityQuestions) {
					AppEventDispatcher.dispatch(AutenticationEventType.SECURITY_CHECK_REGISTRATION.INIT, { show: true });
				} else {
					this.router.navigate(['']);
				}
			}, error => {
				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
			});

		} else {
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: 'Selecione um conta.' });
		}

	}

	show(data: any) {

		this.active = true;
		this.accountsList = Auth.getInstance().getAccountsList();

		for (let i = 0; i < this.accountsList.length; i++) {
			const item = this.accountsList[i];
			if (item.rights === 'TRANSACIONAR') {
				this.myAccountsList.push(item);
			}else {
				this.outersAccountsList.push(item);
			}
		}

		if (!data.delay) {
			data.delay = .1;
		}

		TweenMax.delayedCall(data.delay, () => {

			if ($(window).width() > 992) {
				TweenMax.to('[data-component="login"]', .8, { width: 380, height: 500, ease: Quint.easeOut});
			} else {
				TweenMax.to('[data-component="login"]', .8, { height: 500, ease: Sine.easeOut});
			}

			TweenMax.to('[data-component="login"] .logo', .8, { top: 25, ease: Sine.easeOut});
			TweenMax.to('[data-component="accounts-list"]', .8, { delay: data.delay, left: '50%', ease: Quint.easeOut });
		});
	}

	backToLogin() {
		// TODO: Fazer voltar para tela inicial do login
		this.router.navigate(['']);
	}

	hide() {
		TweenMax.to(this.view, 1.6, {left: '-100%', ease: Quint.easeOut, onComplete: () => {
			this.active = false;
		}});
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/autentication/accounts-list/accounts-list.component.ts